import { Button, Stack, TextField } from '@mui/material'

import type { SecondFactorValue } from './secondFactor'

interface SecondFactorInputProps {
  value: SecondFactorValue
  onChange: (value: SecondFactorValue) => void
  disabled?: boolean
  /** Offer a recovery code in place of the app's code. */
  allowRecovery?: boolean
}

/**
 * The code from the authenticator app, or, when the app is not to hand, one
 * of the recovery codes. A field of its own for each, so the browser offers a
 * one-time code to the first and nothing to the second.
 */
export default function SecondFactorInput({
  value,
  onChange,
  disabled,
  allowRecovery = true,
}: SecondFactorInputProps) {
  const recovery = value.kind === 'recoveryCode'

  return (
    <Stack spacing={1} alignItems="flex-start">
      {recovery ? (
        <TextField
          key="recovery"
          label="Recovery code"
          autoComplete="off"
          value={value.text}
          onChange={(event) =>
            onChange({ kind: 'recoveryCode', text: event.target.value })
          }
          disabled={disabled}
          fullWidth
        />
      ) : (
        <TextField
          key="code"
          label="Code from your authenticator app"
          autoComplete="one-time-code"
          inputProps={{ inputMode: 'numeric', maxLength: 7 }}
          value={value.text}
          onChange={(event) =>
            onChange({ kind: 'code', text: event.target.value })
          }
          disabled={disabled}
          fullWidth
        />
      )}
      {allowRecovery && (
        <Button
          variant="text"
          size="small"
          disabled={disabled}
          onClick={() =>
            onChange({ kind: recovery ? 'code' : 'recoveryCode', text: '' })
          }
        >
          {recovery
            ? 'Use the code from your app instead'
            : 'Use a recovery code instead'}
        </Button>
      )}
    </Stack>
  )
}
